<template>
    <div id="header" class="editorContainer h-100 d-md-flex bg-gris-pro overflow-hidden flex-column flex-md-row">
        <js-editor-mobile v-if="mobile"/>

        <section class="rightSidebar">
            <div>
                <div class="close-sidebar close-sidebar-cart position-absolute rounded-left-10 cursor-pointer" :class="[pieces ? 'filled' : 'disabled', {'open' : !isSidebarOpen}]" block @click="openSidebar" v-if="!mobile || mode == 'blueprint'">
                    <div class="hover">
                        <div id="cart" class="position-relative mx-auto">
                            <img class="d-block mx-auto" src="@/assets/img/panier-mobile.png" width="41" height="40">
                            <span id="qty">{{pieces.length}}</span>
                        </div>
                        <span class="text-white font-weight-bold small" v-if="pieces.length"><t jsEditor.yourPieces /></span>
                        <span class="text-white font-weight-bold small" v-else><t jsEditor.emptyCart /></span><br/>
                        <label class="text-white font-weight-bold mb-0 cursor-pointer text-center d-block totalPrice" v-if="totalPrice">{{Math.round(totalPrice * 100) / 100}}€</label>
                    </div>
                </div>
                <b-sidebar id="sidebar-right" sidebar-class="bg-white" right shadow width="28em" no-header no-close-on-route-change no-close-on-esc :visible="this.isSidebarOpen">
                    <b-icon class="close-sidebar position-absolute p-2 rounded-10 cursor-pointer border-0 d-xl-none" icon="x-circle" font-scale="2.5" @click="openSidebar" v-if="mode == 'workshop'"></b-icon>
                    <blueprint-sidebar v-if="mode == 'blueprint'" />
                    <workshop-sidebar v-if="mode == 'workshop'" />
                </b-sidebar>
            </div>
        </section>

        <div class="d-flex" v-if="!mobile && mode != 'blueprint'">
            <section class="boxes bg-white d-flex flex-column justify-content-between">
                <tool-box v-if="mode == 'workshop'" />
                <div>
                    <history-box v-if="mode == 'workshop'"/>
                </div>
            </section>
        </div>

        <section class="workzone" :class="[{'open': isSidebarOpen}, {'dxf' : mode == 'blueprint'}]">
            <b-overlay
                id="overlay-background"
                :show="loadingStep != ''"
                variant="white"
                opacity="0.90"
                blur="5px"
            >
                <div id="sav-contact-desktop" class="bg-white py-2 d-flex align-items-center rounded-bottom-10 mr-3 mb-1" v-b-modal.modal-sav v-if="!mobile">
                    <div>
                        <img id="sav-call" :src="require('@/assets/img/support.svg')" height="20" width="20" class="ml-3">
                        <span class="font-weight-bold mr-3 mb-0 line-height text-gris"><t JSEditorMobile.sav /></span>
                    </div>
                </div>
                <b-modal id="modal-sav" centered header-class="border-0 pb-0" hide-footer>
                    <img id="moustache-js" class="mx-auto d-block" src="@/assets/img/moustache-js.png" width="80px">
                    <span class="h4 font-weight-bold text-center d-block mt-1"><t JSEditorMobile.johnsteel /></span>
                    <p class="text-center d-none d-md-block">
                        <t JSEditor.description />
                    </p>
                    <div class="d-flex mt-4 text-gris">
                        <div class="col-6 px-0 border-right">
                            <a href="https://www.john-steel.com/fr/nous-contacter" target="_blank">
                                <img class="d-block mx-auto mb-1" src="@/assets/img/icon-mail.png" width="40px">
                                <span class="text-center d-block font-weight-bold text-gris"><t JSEditorMobile.contactUs /></span>
                            </a>
                        </div>
                        <div class="col-6 px-0 border-left">
                            <img class="d-block mx-auto mb-1" src="@/assets/img/icon-phone.png" width="40px">
                            <a href="tel:0800746548" class="text-center d-block font-weight-bold text-gris"><t JSEditorMobile.JSNumber /></a>
                        </div>
                    </div>
                </b-modal>
                <ruler class="h-ruler" v-if="mode == 'workshop' && !tunnelOpen"/>
                <canvas id="js-editor" @touchstart="touchstart" @touchend="touchend" @touchcancel="touchend" @touchmove="touchmove" @wheel="wheelevent" @contextmenu="contextmenu" />
                <template v-slot:overlay>
                    <div class="text-center">
                        <div class="load fadeIn mb-3">
                            <div class="loader-container d-flex align-items-center justify-content-center h-100">
                                <div class="loader">
                                    <svg viewBox="0 0 80 80">
                                        <circle id="test" cx="40" cy="40" r="32"></circle>
                                    </svg>
                                </div>

                                <div class="loader triangle">
                                    <svg viewBox="0 0 86 80">
                                        <polygon points="43 8 79 72 7 72"></polygon>
                                    </svg>
                                </div>

                                <div class="loader">
                                    <svg viewBox="0 0 80 80">
                                        <rect x="8" y="8" width="64" height="64"></rect>
                                    </svg>
                                </div>
                            </div>
                        </div>
                        <h3>{{loadingStep}}</h3>
                    </div>
                </template>
            </b-overlay>
        </section>
    </div>
</template>

<script>

// eslint-disable-next-line
import tools from '../tools';
import ToolBox from '../components/panel/ToolBox';
import HistoryBox from '../components/panel/HistoryBox';
import WorkshopSidebar from '../components/panel/WorkshopSidebar';
import Ruler from '../components/panel/Ruler';
import BlueprintSidebar from '../components/panel/BlueprintSidebar';
import paper from 'paper';
import { Layer, Point } from 'paper';
import { BModal, BOverlay, BIcon, BIconCircleHalf, BSidebar, VBToggle, BIconXCircle, BButton, BIconTelephoneOutbound, VBModal } from 'bootstrap-vue';
import { mapGetters } from 'vuex'
import JsEditorMobile from './panel/JsEditorMobile.vue';
import PathUtils from '../services/PathUtils';
import smoothscroll from 'smoothscroll-polyfill';

export default {
    components: {
        ToolBox,
        WorkshopSidebar,
        HistoryBox,
        BlueprintSidebar,
        Ruler,
        BModal,
        BOverlay,
        BIcon,
        BSidebar,
        BButton,
        BIconTelephoneOutbound,
        JsEditorMobile,
        VBModal,
        // eslint-disable-next-line vue/no-unused-components
        BIconCircleHalf, BIconXCircle
    },
    directives: {
        'b-modal': VBModal,
        'b-toggle': VBToggle },
    data() {
        return {
            originalMultitouchCenter: null,
            ignoreZoom: null,
            multitouchCenter: null,
            multitouchDistance: null,
            mobile:window.innerWidth <= 768,
            tablet:window.innerWidth <= 990,
            cartOpen: false,
            pieceSelected: null,
            isSidebarOpen: null,
            color: null,
            tunnelOpen: window.obelix.tunnel
        }
    },
    created() {
        paper.install(window);
        console.debug("JsEditor created");
        this.responsiveSidebar();

        addEventListener('resize', () => {
            this.mobile = innerWidth <= 768;
            this.tablet = innerWidth <= 990;
            this.$store.dispatch('setMobileDevice', this.mobile);
            
            this.resizeCanvas();
            this.responsiveSidebar();
        });
    },
    async mounted() {
        paper.setup("js-editor");

        paper.settings.handleSize = 8;

        paper.project.addLayer(new Layer({name: "temp"}));
        paper.project.addLayer(new Layer({name: "blueprint"}));
        paper.project.addLayer(new Layer({name: "import"}));
        paper.project.addLayer(new Layer({name: "view"}));
        paper.project.addLayer(new Layer({name: "selectable"}));
        paper.project.addLayer(new Layer({name: "selecter"}));

        this.$store.dispatch('initEditor');
        this.$store.dispatch('setMobileDevice', this.mobile);

        this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
            if (modalId == 'modal-1') {
                this.tunnelOpen = false;
            }
        });
        smoothscroll.polyfill();
    },

    watch: {
        '$route.params.compositionId': async function (compositionId) {
            if (compositionId == this.$store.getters.compositionId) return;

            this.$store.dispatch('setCompositionId', compositionId);
            this.$store.dispatch('initEditor')
            .catch(async error => {
                await this.$store.dispatch('setEditorError', error);
                if (this.$route.name != 'error') this.$router.replace({name: 'error'});
            });
        },
        tool() {
            if (document.getElementById('arrow')) {
                document.getElementById('arrow').beginElement();
            }
        },
        materialName() {
            if (this.materialName == 'Metal') {
                this.color = '#dbd8d8'
            } else {
                this.color = '#eab875'
            }
        }
    },
    computed: {
        ...mapGetters([
            'loadingStep',
            'mode',
            'center',
            'zoom',
            'pieces',
            'totalPrice',
            'user',
            'toolSelected',
            'tool',
            'toolType',
            'materialName',
            'selectedShape'
        ]),
        authenticated: function () {
            return this.user != null;
        },
        uniquePieces: function() {
            return this.pieces ? this.pieces.filter(p => !p.isCopyOf) : []
        }
    },
    methods: {
        async wheelevent(event) {
            event.preventDefault();

            let zoomFactor;
            if (event.ctrlKey) {
                // pinch touchpad
                zoomFactor = event.deltaY < 0 ? 1.1111 : 0.9;
            }
            else {
                // scroll roulette
                zoomFactor = event.deltaY < 0 ? 1.25 : 0.8;
            }

            let newZoom = this.zoom * zoomFactor;

            if(this.mobile){
                if (newZoom < 0.05) newZoom = 0.05;
            }else{
                 if (newZoom < 0.2) newZoom = 0.2;
            }
            if (this.mode == "blueprint" && newZoom > 10000000) newZoom = 10000000;
            if (this.mode == "workshop" && newZoom > 200) newZoom = 200;

            // point stable : position de la souris dans le projet
            let mouseInProject = new Point(
                paper.view.bounds.x + (event.layerX / this.zoom),
                paper.view.bounds.y + (event.layerY / this.zoom)
            );

            let oldCenter = paper.view.bounds.center,
                mouseToCenter = oldCenter.subtract(mouseInProject),
                realFactor = this.zoom / newZoom,
                mouseToNewCenter = mouseToCenter.multiply(realFactor),
                newCenter = mouseInProject.add(mouseToNewCenter);

            this.$store.dispatch('setZoomCenter',
                {
                    zoom: newZoom,
                    center: newCenter
                }
            );
        },
        async contextmenu(event) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        },
        touchstart(event) {
            if (event.touches.length > 1 && !this.$store.getters.multitouch) {
                this.$store.dispatch('setMultitouch', true);

                this.multitouchDistance = this.touchDistance(event.touches[0], event.touches[1]);
                this.multitouchCenter = this.touchCenter(event.touches[0], event.touches[1]);
                this.originalMultitouchDistance = this.touchDistance(event.touches[0], event.touches[1]);
                this.ignoreZoom = true;
                this.previousTouches = event.touches;
            }
        },
        touchend(event) {
            if (event.touches.length < 2) {
                this.multitouchDistance = null;
                this.multitouchCenter = null;
            }
            if (event.touches.length == 0 && this.$store.getters.multitouch) {
                this.$store.dispatch('setMultitouch', false);
                this.previousTouches = [];
            }
        },
        touchmove(event) {
            if (event.touches.length >= 2) {
                if (this.multitouchDistance == null || this.multitouchCenter == null) {
                    this.multitouchDistance = this.touchDistance(event.touches[0], event.touches[1]);
                    this.multitouchCenter = this.touchCenter(event.touches[0], event.touches[1]);
                    return;
                }
                let newDistance =  this.wobblyTouchDistance(event.touches[0], event.touches[1]);
                let zoomFactor = newDistance / this.multitouchDistance;
                let newZoom = this.zoom * zoomFactor;

                if(this.mobile){
                    if (newZoom < 0.05) newZoom = 0.05;
                }else{
                    if (newZoom < 0.2) newZoom = 0.2;
                }
                if (this.mode == "blueprint" && newZoom > 10000000) newZoom = 10000000;
                if (this.mode == "workshop" && newZoom > 200) newZoom = 200;

                let newCenter = this.touchCenter(event.touches[0], event.touches[1]);
                let moveVector = newCenter.subtract(this.multitouchCenter);
                let zoomedMoveVector = moveVector.divide(newZoom * 1.44);

                let viewCenter = this.center.subtract(zoomedMoveVector);

                this.$store.dispatch('setZoomCenter',
                    {
                        zoom: newZoom,
                        center: viewCenter
                    }
                );

                if (newDistance != 0) this.multitouchDistance = newDistance;
                this.multitouchCenter = newCenter;
            }
        },

        wobblyTouchDistance(first, second) {
            let distance = this.touchDistance(first, second);
            if (this.ignoreZoom
                && distance > this.originalMultitouchDistance * 0.9
                && distance < this.originalMultitouchDistance * 1.11) return this.originalMultitouchDistance;

            this.ignoreZoom = false;
            return distance;
        },

        touchDistance(first, second) {
            let x = second.screenX - first.screenX,
                y = second.screenY - first.screenY;
            return Math.sqrt(x * x + y * y);
        },

        touchCenter(first, second) {
            return new Point(
                first.screenX + second.screenX / 2,
                first.screenY + second.screenY / 2
            );
        },

        resizeCanvas() {
            let width = document.querySelector('.workzone').offsetWidth;
            let height = document.querySelector('.workzone').offsetHeight;
            paper.view.viewSize = new paper.Size(width, height);
            PathUtils.autoZoom();
        },

        returnBack(){
            window.history.back();
        },
        openSidebar() {
            this.$root.$emit('bv::toggle::collapse', 'sidebar-right');
            this.isSidebarOpen = !this.isSidebarOpen;
            this.$nextTick(() => {
                this.resizeCanvas();
            });
        },
        responsiveSidebar() {
            this.isSidebarOpen = !this.tablet;
        },
    }
};
</script>

<style lang="scss">
    @import './../assets/scss/_variables.scss';

    html {
        overflow-x: initial!important;
    }

    body {
        font-family: 'Open Sans', sans-serif;
        margin: 0;
        padding: 0;
    }

    a:hover {
        text-decoration: none!important;
    }

    #sav-contact-desktop {
        position: absolute;
        top: 0;
        right: 0;
        transition: all .2s ease-in-out;

        img {
            transition: all .2s ease-in-out;
        }

        &:hover {
            padding-top: 10px!important;
            background: $jaune!important;
            columns: $white!important;

            img {
                animation: swing .5s;
            }
        }
    }

    #cart {
        #qty {
            right: 10px;
        }
    }

    body#module-johnsteel_editeur-editor,
    body,
    html {
        height: 100%!important;
    }

    main {
        height: 100%;

        #wrapper {
            height: 100%;

            > .container {
                height: 100%;
            }
        }
    }

    .text-gris-2 {
        color: $gris2;
    }

    #qty {
        background: $jaune;
        border-radius: 50%;
        color: $white;
        transition: all .3s ease-in-out;
        padding: 0;
        text-align: center;
        font-weight: bold;
        height: 20px;
        width: 20px;
        position: absolute;
        top: -5px;
        right: -10px;
        font-size: 80%;

        @media (max-width: 576px) {
            font-size: 90%;
        }
    }

    #cart-mobile {
        width: 36px;

        @media (max-width: 576px) {
            width: 32px;
        }
    }

    #moustache-js {
        margin-top: -95px;
    }

    .filled {
        background-color: $rose!important;
    }

    .position-inherit {
        position: inherit;
    }

    .navToggle {
        z-index: 2!important;
    }

    .boxes {
        padding: 0;
        z-index: 0;
        border-right: 4px solid $rose;
        z-index: 1;
    }

    .modal-content {
        border-radius: 10px!important;
    }

    #overlay-background {
        height: 100%;
        width: 100%;
        position: absolute !important;
    }

    #touch-layer {
        height: 100%;
        width: 100%;
    }

    .workzone {
        position: relative;
        height: 100%;
        width: calc(100% - 33em);
        &.dxf {
            width: calc(100% - 28em);
        }

        &:not(.open) {
            width: calc(100% - 4em);
        }
        @media (max-width: 990px) {
            width: 100%!important;
        }
    }

    canvas {
        background: #f2f2f2;
        width: 100%;
        height: 100%;

        @media (max-width: 768px) {
            background: #fff;
        }
    } 

    .h-ruler {
        position: absolute;
        bottom: 0.5em;
        right:  0.5em;
        border-radius: 1rem;

        @media (max-width: 768px) {
            bottom: 150px;
            right: 8px;
        }
    }

    .editorContainer {
        @media (max-width: 768px) {
            background: $white!important;
        }

        &.disabled {
            display: none;
        }
    }

    .addtocart {
        z-index: 0!important;
    }

    #menu-mobile {
        bottom: 0;
        z-index: 1;

        .btn-secondary {
            padding: 0;
            background: transparent;
            border: 0;
            outline: 0;
            box-shadow: none!important;
        }

        &:before {
            content: "";
            width: 100%;
            display: block;
            bottom: 0;
            position: absolute;
            z-index: -1;
            height: 83px;
            background: #fff;
        }
    }

    .cart-open.bg-gris {
        position: relative;
        border-radius: 10px 0 10px 0!important;
    }

    .slide-enter, .slide-leave-to {
        max-height: 0;
    }
    .slide-enter-active {
        transition: max-height .5s ease-in-out;
    }
    .slide-leave {
        transition: none;
    }
    .slide-leave-active {
        max-height: 0;
        transition: 0;
    }
    .slidecart-leave-active {
        max-height: 0;
        opacity: 0;
        transition: all .5s ease!important;
    }
    .close-sidebar-cart {
        transition-delay: .4s;
        transition-duration: .3s;
        transition-property: all;
        transition-timing-function: ease-in-out;
        right: -125px;

        .hover {
            transition: all .3s ease-in-out;

            &:hover {
                padding-right: 5px!important;
                img {
                    transform: rotate(-10deg);
                }
                #qty {
                    transform: scale(1.2) rotate(5deg);
                }
            }
        }

        &.open {
            right: 0!important;
        }

        @media (min-width: 768px) {
            background: $rose;
            opacity: 1!important;
        }
    }

    .loader {
        display: inline-block;
        margin: 0 16px;
        --path: #646363;
        --dot: #7db9e8;
        --duration: 3s;
        width: 44px;
        height: 44px;
        position: relative;
        &:before {
            content: '';
            width: 6px;
            height: 6px;
            border-radius: 50%;
            position: absolute;
            display: block;
            background: var(--dot);
            top: 37px;
            left: 19px;
            transform: translate(-18px, -18px);
            animation: dotRect var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
        }
        svg {
            display: block;
            width: 100%;
            height: 100%;
            rect,
            polygon,
            circle {
                fill: none;
                stroke: var(--path);
                stroke-width: 10px;
                stroke-linejoin: round;
                stroke-linecap: round;
            }
            polygon {
                stroke-dasharray: 145 (221 - 145) 145 (221 - 145);
                stroke-dashoffset: 0;
                animation: pathTriangle var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
            }
            rect {
                stroke-dasharray: (256 / 4 * 3) (256 / 4) (256 / 4 * 3) (256 / 4);
                stroke-dashoffset: 0;
                animation: pathRect 3s cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
            }
            circle {
                stroke-dasharray: (200 / 4 * 3) (200 / 4) (200 / 4 * 3) (200 / 4);
                stroke-dashoffset: 75;
                animation: pathCircle var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
            }
        }
        &.triangle {
            width: 48px;
            &:before {
                left: 21px;
                transform: translate(-10px, -18px);
                animation: dotTriangle var(--duration) cubic-bezier(0.785, 0.135, 0.15, 0.86) infinite;
            }
        }
    }

    .close-sidebar {
        right: 0;
        background: $white;
        overflow: auto;
        top: 40vh;
        z-index: 1;
        transition: all .3s ease-in-out;

        img {
            transition: all .3s ease-in-out;
            height: 40px!important;
        }
    }

    #sidebar-right {        
        .close-sidebar {
            top: 15px;
            right: 15px;
            z-index: 100;
        }
    }

    .rightSidebar {
        .close-sidebar {
            padding: 1rem 1rem .5rem 1rem;
        }

        .b-sidebar-body {
            position: relative;
            overflow: visible!important;
        }

        .fly-over-tool {
            position: absolute;
            left: -350px;
            z-index: -1;
            width: 350px;
            margin-top: -40px;

            &:after {
                position: absolute;
                content: 'x';
                width: 25px;
                height: 25px;
                color: white;
                font-weight: bold;
                top: 5px;
                right: 3px;
            }
        }
    }

    @keyframes pathTriangle {
        33% {
            stroke-dashoffset: 74;
        }
        66% {
            stroke-dashoffset: 147;
        }
        100% {
            stroke-dashoffset: 221;
        }
    }

    @keyframes dotTriangle {
        33% {
            transform: translate(0, 0);
        }
        66% {
            transform: translate(10px, -18px);
        }
        100% {
            transform: translate(-10px, -18px);
        }
    }

    @keyframes pathRect {
        25% {
            stroke-dashoffset: 64;
        }
        50% {
            stroke-dashoffset: 128;
        }
        75% {
            stroke-dashoffset: 192;
        }
        100% {
            stroke-dashoffset: 256;
        }
    }

    @keyframes dotRect {
        25% {
            transform: translate(0, 0);
        }
        50% {
            transform: translate(18px, -18px);
        }
        75% {
            transform: translate(0, -36px);
        }
        100% {
            transform: translate(-18px, -18px);
        }
    }

    @keyframes pathCircle {
        25% {
            stroke-dashoffset: 125;
        }
        50% {
            stroke-dashoffset: 175;
        }
        75% {
            stroke-dashoffset: 225;
        }
        100% {
            stroke-dashoffset: 275;
        }
    }

    @keyframes swing { 
        20% { transform: rotate(15deg); } 
        40% { transform: rotate(-10deg); } 
        60% { transform: rotate(5deg); } 
        80% { transform: rotate(-5deg); } 
        100% { transform: rotate(0deg); } 
    }   
</style>
